module.exports = __webpack_public_path__ + "img/7.4df2f422.jpg";